/**
 * Generation request/response types for AI context
 *
 * Placeholder — populated as services are moved in P2.
 */
export {};
